var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    d: "M12,20.2c-1.48,0-2.94-0.23-4.33-0.67l-1.26-0.4l-1.08,0.76c-0.79,0.56-1.87,1.18-3.18,1.6 c0.4-0.67,0.8-1.42,1.1-2.22l0.59-1.55L2.7,16.51c-1-1.07-2.2-2.83-2.2-5.16C0.5,6.47,5.66,2.5,12,2.5s11.5,3.97,11.5,8.85 S18.34,20.2,12,20.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#d3d3d3",
    cx: 17.26,
    cy: 16.62,
    r: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.51,15.77l-0.65,0.51c-0.07,0.05-0.16,0.03-0.21-0.04l-1.11-1.76c-0.05-0.07-0.03-0.18,0.04-0.23l0.65-0.51 c0.27-0.21,0.63-0.13,0.82,0.16l0.6,0.95C20.84,15.15,20.78,15.56,20.51,15.77z M18.01,14.68l-3.73,2.9l-0.51,1.59 c-0.07,0.21,0.07,0.44,0.28,0.44l1.51,0.01l3.73-2.9c0.07-0.05,0.08-0.15,0.04-0.23l-1.11-1.76C18.17,14.65,18.08,14.63,18.01,14.68 L18.01,14.68z M15.58,17.53c-0.05-0.09-0.04-0.21,0.04-0.27l2.18-1.7c0.08-0.06,0.18-0.04,0.24,0.05c0.05,0.09,0.04,0.21-0.04,0.27 l-2.18,1.7C15.74,17.64,15.63,17.62,15.58,17.53L15.58,17.53z M14.96,18.57l0.58,0.12l-0.08,0.49l-0.8,0l-0.31-0.49l0.27-0.84 l0.44,0.09L14.96,18.57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.f5637cd186a21219438ef41fa15c1126.svg";
export { ForwardRef as ReactComponent };